import React from 'react';
import Lookup from './Lookup';
import LocationInactive from './LocationInactive';
import GeolocationDenied from './GeolocationDenied';
import DefaultLookup from './DefaultLookup';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './main.css';
import './remote-polish.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useCookies, withCookies } from 'react-cookie';

function App() {
  const location_granted = useSelector(state=> state.location_granted)
  const location_error = useSelector(state=> state.error)
  const [cookies] = useCookies(['location_granted']);

  const location_granted_cookie = cookies.location_granted
 


  
  if(location_error === "NONE"){
    return (location_granted || location_granted_cookie === true || location_granted_cookie === 'true') ? (
      <div>
      <Router>
        <>
        <Switch>
        < Route exact path="/" component={DefaultLookup} />
        < Route path="/:qr_id" component={Lookup} />
        </Switch>
        </>
      </Router>
      </div>

    ) : 
    (
      <div>
        <LocationInactive />
      </div>
    );
    }else{
      return  (
        <GeolocationDenied />
      )
    }
}

export default withCookies(App);
